import React from "react";
import { Box, Text, type TextProps } from "@chakra-ui/react";

export function Tab({ isActive, children, ...props }: TextProps & { isActive?: boolean }) {
  return (
    <Text
      textStyle={{ base: "caption2", lg: "caption1" }}
      fontWeight="semibold"
      pb={{ base: "tiny", lg: "smallest" }}
      px="tinier"
      pos="relative"
      {...props}
    >
      {children}
      {isActive && (
        <Box aria-hidden as="span" pos="absolute" left={0} bottom="-2px" right={0} h="4px" bg="brand.text.light" />
      )}
    </Text>
  );
}
